import { SvgProps } from "@/utils/types";

export const Strawberry = ({
  primaryColor = "#F96E09",
  secondaryColor = "#D4DF65",
  outlineColor = "#0E5654",
  className,
}: SvgProps) => {
  return (
    <svg
      width="57"
      height="70"
      viewBox="0 0 57 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_5_606)">
        <path
          d="M13.9294 42.3339C9.74455 32.226 14.6083 25.1254 22.8221 21.7247C31.036 18.324 39.4993 19.9177 43.6804 30.0164C47.8615 40.1151 47.2476 57.4807 39.0338 60.8814C30.8199 64.2821 18.1143 52.4418 13.9294 42.3339Z"
          fill={primaryColor}
        />
        <path
          d="M39.7836 62.6923C30.1007 66.7013 16.5406 53.7645 12.1185 43.0837C7.96424 33.0497 11.7797 24.1752 22.0724 19.9138C32.3651 15.6524 41.3371 19.2327 45.4913 29.2667C49.9134 39.9475 49.4665 58.6834 39.7836 62.6923ZM23.5719 23.5356C19.6452 25.1614 11.0161 30.1735 15.7442 41.5934C19.7952 51.378 31.6817 61.8148 38.2879 59.0797C44.8941 56.3446 45.9243 40.56 41.8733 30.7754C37.1491 19.3647 27.4987 21.9099 23.5719 23.5356Z"
          fill={outlineColor}
        />
        <path
          d="M24.2828 28.9126C24.0227 28.2844 24.3243 27.575 24.9434 27.3187C25.5624 27.0624 26.281 27.3602 26.5373 27.9793C26.7936 28.5983 27.368 31.4235 26.7489 31.6798C26.1299 31.936 24.543 29.5409 24.2828 28.9126Z"
          fill={outlineColor}
        />
        <path
          d="M18.4989 30.9934C18.4166 30.324 18.8995 29.7128 19.5689 29.6305C20.2384 29.5481 20.8496 30.031 20.9319 30.7005C21.0142 31.3699 20.8055 34.2379 20.136 34.3202C19.4666 34.4025 18.5813 31.6628 18.4989 30.9934Z"
          fill={outlineColor}
        />
        <path
          d="M32.1179 25.3549C31.7029 24.8232 30.9293 24.7322 30.3976 25.1472C29.8658 25.5621 29.7749 26.3358 30.1898 26.8675C30.6048 27.3992 32.7798 29.2803 33.3115 28.8653C33.8432 28.4504 32.5328 25.8866 32.1179 25.3549Z"
          fill={outlineColor}
        />
        <path
          d="M30.3729 42.8641C30.1128 42.2358 30.4144 41.5265 31.0335 41.2702C31.6525 41.0139 32.3711 41.3117 32.6274 41.9307C32.8837 42.5498 33.458 45.3749 32.839 45.6312C32.22 45.8875 30.6331 43.4924 30.3729 42.8641Z"
          fill={outlineColor}
        />
        <path
          d="M34.4203 53.581C34.1602 52.9527 34.4618 52.2434 35.0808 51.9871C35.6999 51.7308 36.4184 52.0286 36.6747 52.6476C36.931 53.2666 37.5054 56.0918 36.8864 56.3481C36.2673 56.6044 34.6804 54.2093 34.4203 53.581Z"
          fill={outlineColor}
        />
        <path
          d="M22.9976 43.8721C22.7375 43.2438 23.0391 42.5345 23.6581 42.2782C24.2771 42.0219 24.9957 42.3197 25.252 42.9387C25.5083 43.5578 26.0827 46.3829 25.4636 46.6392C24.8446 46.8955 23.2577 44.5004 22.9976 43.8721Z"
          fill={outlineColor}
        />
        <path
          d="M36.3024 38.3636C36.0423 37.7353 36.3439 37.026 36.9629 36.7697C37.5819 36.5134 38.3005 36.8112 38.5568 37.4303C38.8131 38.0493 39.3875 40.8744 38.7685 41.1307C38.1494 41.387 36.5625 38.9919 36.3024 38.3636Z"
          fill={outlineColor}
        />
        <path
          d="M23.8255 36.2778C23.5653 35.6495 23.8669 34.9402 24.486 34.6839C25.105 34.4276 25.8236 34.7254 26.0799 35.3444C26.3362 35.9635 26.9106 38.7886 26.2915 39.0449C25.6725 39.3012 24.0856 36.9061 23.8255 36.2778Z"
          fill={outlineColor}
        />
        <path
          d="M17.3395 38.9631C17.0794 38.3349 17.381 37.6255 18 37.3692C18.6191 37.113 19.3376 37.4107 19.5939 38.0298C19.8502 38.6488 20.4246 41.474 19.8056 41.7303C19.1865 41.9866 17.5996 39.5914 17.3395 38.9631Z"
          fill={outlineColor}
        />
        <path
          d="M30.3485 33.5771C30.0884 32.9488 30.39 32.2395 31.009 31.9832C31.6281 31.7269 32.3466 32.0247 32.6029 32.6437C32.8592 33.2628 33.4336 36.0879 32.8146 36.3442C32.1956 36.6005 30.6086 34.2054 30.3485 33.5771Z"
          fill={outlineColor}
        />
        <path
          d="M28.1455 49.9014C27.8854 49.2731 28.187 48.5638 28.806 48.3075C29.4251 48.0512 30.1436 48.349 30.3999 48.968C30.6562 49.5871 31.2306 52.4122 30.6116 52.6685C29.9925 52.9248 28.4056 50.5297 28.1455 49.9014Z"
          fill={outlineColor}
        />
        <path
          d="M36.923 46.2674C36.6629 45.6391 36.9645 44.9298 37.5835 44.6735C38.2025 44.4172 38.9211 44.715 39.1774 45.334C39.4337 45.953 40.0081 48.7782 39.3891 49.0345C38.77 49.2908 37.1831 46.8957 36.923 46.2674Z"
          fill={outlineColor}
        />
        <path
          d="M36.7052 30.9453C36.4451 30.317 36.7467 29.6077 37.3657 29.3514C37.9848 29.0951 38.7033 29.3929 38.9596 30.0119C39.2159 30.631 39.7903 33.4561 39.1713 33.7124C38.5522 33.9687 36.9653 31.5736 36.7052 30.9453Z"
          fill={outlineColor}
        />
        <path
          d="M30.7026 15.7671C29.1 19.6342 25.1377 20.3115 25.1377 20.3115C25.1377 20.3115 22.8158 17.03 24.4184 13.1629C26.021 9.29573 29.9833 8.61851 29.9833 8.61851C29.9833 8.61851 32.3051 11.8999 30.7026 15.7671Z"
          fill={secondaryColor}
        />
        <path
          d="M27.3072 21.8917C26.3094 22.3049 25.5829 22.4325 25.5014 22.4446L24.1578 22.6762L23.3718 21.5621C23.2453 21.3872 20.3708 17.2415 22.4157 12.3253C24.4569 7.39989 29.412 6.50646 29.6251 6.47232L30.9687 6.24074L31.7547 7.35482C31.8812 7.52972 34.7557 11.6755 32.7107 16.5916C31.4276 19.688 28.985 21.1863 27.3034 21.8825L27.3072 21.8917ZM28.8572 11.336C28.0085 11.7956 26.9951 12.6156 26.4304 13.9967C25.8619 15.3685 25.9983 16.6649 26.2769 17.5994C27.1256 17.1398 28.139 16.3198 28.7037 14.9387C29.2722 13.5669 29.1359 12.2705 28.8572 11.336Z"
          fill={outlineColor}
        />
        <path
          d="M11.954 23.9948C8.08679 22.3922 7.40958 18.4299 7.40958 18.4299C7.40958 18.4299 10.691 16.1081 14.5581 17.7107C18.4253 19.3132 19.1025 23.2756 19.1025 23.2756C19.1025 23.2756 15.8211 25.5974 11.954 23.9948Z"
          fill={secondaryColor}
        />
        <path
          d="M18.685 25.9269C17.0034 26.6231 14.2127 27.2807 11.1202 26.0068C6.20404 23.9618 5.30678 18.9975 5.27264 18.7843L5.04106 17.4407L6.15514 16.6548C6.33005 16.5282 10.4758 13.6537 15.3919 15.6987C20.3173 17.7398 21.2108 22.6949 21.2449 22.9081L21.4765 24.2517L20.3624 25.0376C20.2961 25.0867 19.6921 25.51 18.6943 25.9231L18.685 25.9269ZM12.7785 21.9867C14.1634 22.5606 15.4468 22.4188 16.3813 22.1402C15.9216 21.2914 15.1016 20.2781 13.7167 19.7042C12.3319 19.1303 11.0485 19.272 10.114 19.5506C10.5736 20.3994 11.3936 21.4128 12.7785 21.9867Z"
          fill={outlineColor}
        />
        <path
          d="M23.0068 13.9097C24.6096 17.781 22.2775 21.0627 22.2775 21.0627C22.2775 21.0627 18.3083 20.3899 16.7055 16.5186C15.1027 12.6473 17.4347 9.36558 17.4347 9.36558C17.4347 9.36558 21.404 10.0384 23.0068 13.9097Z"
          fill={secondaryColor}
        />
        <path
          d="M23.2606 23.4372L21.9096 23.2065C21.7012 23.1737 16.7394 22.2733 14.7005 17.3487C12.6616 12.4241 15.5386 8.28901 15.6629 8.11852L16.4554 7.0003L17.8064 7.23105C18.0148 7.26383 22.9766 8.16426 25.0155 13.0889C27.0544 18.0135 24.1774 22.1485 24.057 22.3283L23.2645 23.4465L23.2606 23.4372ZM18.5631 12.0912C18.2903 13.0268 18.1497 14.308 18.7235 15.6939C19.2973 17.0798 20.3024 17.8867 21.1567 18.3556C21.4296 17.42 21.5702 16.1388 20.9964 14.7529C20.4226 13.367 19.4175 12.5601 18.5631 12.0912Z"
          fill={outlineColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_5_606">
          <rect
            width="36.11"
            height="60.38"
            fill="white"
            transform="translate(0 13.8132) rotate(-22.4905)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
